import { Component } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

export type NotifierData = {
  header: string;
  message: string;
  buttonText: string;
  link: string;
};

@Component({
  selector: "app-notifier",
  templateUrl: "./notifier.component.html",
  styleUrls: ["./notifier.component.scss"],
  standalone: false,
})
export class NotifierComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotifierData,
    public snackBarRef: MatSnackBarRef<NotifierComponent>,
  ) {}
}
